import { Box, Grid, Link, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { post } from '../../api';

function RecommendedProvider({ solutionSuggestedTaskId }) {
    const theme = useTheme();
    const [providers, setProviders] = useState([]);

    useEffect(() => {
        setProviders([]);
        if (!solutionSuggestedTaskId) return;
        post('custom/getRecommendedProvider', { solutionSuggestedTaskId: solutionSuggestedTaskId }).then((result) => {
            if (result.isSuccess) {
                setProviders(result.data);
            }
        });
    }, [solutionSuggestedTaskId]);

    const getBadgeColor = (badgeColor) => {
        switch (badgeColor) {
            case 'Blue':
                return theme.palette.background.blue;
            case 'Green':
                return theme.palette.background.green;
            case 'Orange':
                return theme.palette.background.orange;
            case 'Red':
                return theme.palette.background.red;
            default:
                return theme.palette.background.blue;
        }
    };
    return (
        <>
            {providers.length > 0 && (
                <Box
                    sx={{
                        padding: `${theme.typography.generic.none} ${theme.typography.generic.xxxLarge}`,
                        paddingBottom: theme.typography.generic.xLarge,
                    }}
                >
                    <Typography component={'h5'} variant='paraText1'  color={'text.secondary'}>Recommended Providers</Typography>

                    <Grid container spacing={1} rowGap={1} sx={{ marginTop: '0.5rem' }}>
                        {providers.map((cItem) => (
                            <Grid item xs={12} sm={6}>
                                <Box position={'relative'} border={`1px solid ${theme.palette.grey[1200]}`} borderRadius={'10px'} padding={'0.5rem'}>
                                    <Box
                                        sx={{
                                            width: '100%',
                                        }}
                                    >
                                        <img style={{ height: '1.6rem', width: 'auto' }} src={cItem.img} alt={cItem.name} />
                                    </Box>

                                    <Box width={'100%'} overflow={'auto'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} marginTop={'0.8rem'}>
                                        <Box display={'flex'} justifyContent={'start'} alignItems={'center'} sx={{ width: 'calc(100% - 78px)' }}>
                                            <Typography
                                                component={'span'}
                                                variant='paraText2'
                                                color={'text.secondary'}
                                                sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                            >
                                                {cItem.name}
                                            </Typography>
                                        </Box>

                                        <Link
                                            variant="body2"
                                            color={theme.palette.primary.main}
                                            underline="none"
                                            fontSize={theme.typography.customFontSize.xSmall}
                                            fontWeight={'fontWeightMedium'}
                                            sx={{
                                                '&:hover': {
                                                    textDecoration: 'underline',
                                                },
                                                marginLeft: '0.8rem',
                                                whiteSpace: 'nowrap',
                                            }}
                                            display={'flex'}
                                            justifyContent={'end'}
                                            alignItems={'center'}
                                            href={cItem.link} // Use https:// for external links
                                            target="_blank" // Opens in a new tab
                                            rel="noopener noreferrer" // Prevents security vulnerabilities
                                        >
                                            {`Go to site >`}
                                        </Link>
                                    </Box>

                                    <Box
                                        display={'flex'}
                                        justifyContent={'start'}
                                        alignItems={'center'}
                                        sx={{
                                            position: 'absolute',
                                            top: '-10px',
                                            right: '10px',
                                        }}
                                    >
                                        {cItem.badgeText && (
                                            <Typography
                                                component={'span'}
                                                color={'text.secondary'}
                                                fontSize={'customFontSize.xxSmall'}
                                                fontWeight={'fontWeightSemiBold'}
                                                lineHeight={'normal'}
                                                borderRadius={theme.typography.borderRadius.xxxSmall}
                                                bgcolor={getBadgeColor(cItem.badgeColor)}
                                                display={'flex'}
                                                justifyContent={'center'}
                                                alignItems={'center'}
                                                padding={theme.typography.generic.xxxSmall}
                                            >
                                                {cItem.badgeText}
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}
        </>
    );
}
export default RecommendedProvider;
